
import React, { Component } from 'react'
import axios from 'axios'
import "../styles/chatbutton.css";



class Chatbutton extends Component {
    onFormSubmit(event)
    {
      event.preventDefault();
        window.location.replace("/chat");
        
    }

	render() {
		
		return (
            <div>
           <form onSubmit={this.onFormSubmit}  id="buttonchat" >
             <div>
             
                <button class="btn btn-dark button2 "  >
                <i class="bi bi-chat"></i>&nbsp;
                    Talk to us
                  </button>
                  
                  </div>
                </form>
          </div>
          
		)
	}
}

export default Chatbutton

